<template>
  <v-container>
    <h1>
      BIENVENIDO:
    </h1>
    <v-row>
       <v-col
          cols="12"
          md="6"
       >
       <h2>
      Utilize este botón para actualizar los productos
       </h2>
       </v-col>
        <v-col
          cols="12"
          md="6"
       >
       <v-btn
          @click="ejecutar"
          color="primary"
        >
          actualizar
        </v-btn>
        </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'Inicio',
    data () {
      return {
      }
    },
    mounted () {
    },
    methods: {
      ejecutar () {
        this.ejecutar = []
        axios.post(window.location.protocol + '//' + window.location.hostname + ':' + this.$session.get('puerto') + 'ejecutar/', this.$session.get('iduser'),
                   { headers: { Authorization: 'JWT ' + this.$session.get('token') } })
          .then((response) => {
            this.ejecutar = response.data
            this.$swal({
              text: 'SE ACTUALIZO EXITOSAMENTE',
              showConfirmButton: true,
              showCloseButton: false,
              showCancelButton: false,
              timer: 1000,
              icon: 'success',
            })
          }).catch((error) => {
            this.$swal({
              text: 'SE GENERO UN ERROR',
              showConfirmButton: true,
              showCloseButton: false,
              showCancelButton: false,
              timer: 1000,
              icon: 'error',
            })
            console.log(error)
          })
      },
    },
  }
</script>
